import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { PENDING_WITHDRAWALS_PERMISSIONS } from '@modules/pending-withdrawals/constants';

import type {
  IPendingWithdrawalsItem,
} from '../types';
import {
  PENDING_WITHDRAWALS_ITEM_QUERY_KEY,
  PENDING_WITHDRAWALS_ITEM_URL,
} from '../constants';

export default function usePendingWithdrawalsItemQuery(
  id: Ref<number>,
): IContextQueryResult<IPendingWithdrawalsItem[], Error, IPendingWithdrawalsItem | undefined> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IPendingWithdrawalsItem[], Error, IPendingWithdrawalsItem | undefined>({
    queryKey: [PENDING_WITHDRAWALS_ITEM_QUERY_KEY, id],
    queryFn: async ({ signal }) => fetchGet<IPendingWithdrawalsItem[]>(
      PENDING_WITHDRAWALS_ITEM_URL,
      {
        signal,
        permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data[0],
    enabled: computed(() => !!id.value),
  });
}
